module.exports = __webpack_public_path__ + "static/media/01_2.c91769ce.png";